/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { RewardsAndOffersContext } from '.';
import { getPaintMembership } from '../utils/GeneralUtil';
var RewardsHubContext = React.createContext(null);
var determineMembershipLevel = function (rewardsAndOffers) {
    var _a, _b;
    var currentTierName = (_b = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _a === void 0 ? void 0 : _a.currentTierName) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    return (currentTierName || 'MEMBER');
};
var RewardsHubProvider = function (_a) {
    var children = _a.children, isMobile = _a.isMobile;
    var _b = React.useContext(RewardsAndOffersContext), rewardsAndOffers = _b.rewardsAndOffers, isLoading = _b.isLoading;
    var membershipLevel = determineMembershipLevel(rewardsAndOffers);
    var paintMembership = getPaintMembership(rewardsAndOffers);
    var paintInfo = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.paintInfo;
    var paintLevel = (paintInfo === null || paintInfo === void 0 ? void 0 : paintInfo.currentLevel) || 'Member';
    var paintSpend = (paintInfo === null || paintInfo === void 0 ? void 0 : paintInfo.spend) || 0;
    var nextLevelName = (paintMembership === null || paintMembership === void 0 ? void 0 : paintMembership.nextLevelName) || '';
    var progressPercentage = (paintMembership === null || paintMembership === void 0 ? void 0 : paintMembership.progressPercentage) || 0;
    var amountRequired = parseInt("".concat((paintMembership === null || paintMembership === void 0 ? void 0 : paintMembership.amtReqToNextLevel) || 0), 10);
    var nextDiscountPercentage = parseInt("".concat((paintMembership === null || paintMembership === void 0 ? void 0 : paintMembership.nextLevelDiscountPercentage) || 0), 10);
    var isPageLoaded = !isLoading;
    return (React.createElement(RewardsHubContext.Provider, { value: {
            isMobile: isMobile,
            membershipLevel: membershipLevel,
            paintLevel: paintLevel,
            paintSpend: paintSpend,
            nextLevelName: nextLevelName,
            progressPercentage: progressPercentage,
            amountRequired: amountRequired,
            nextDiscountPercentage: nextDiscountPercentage,
            isPageLoaded: isPageLoaded,
        } }, children));
};
export { RewardsHubProvider, RewardsHubContext };
